import { CORE_NEEDS, needLabel } from "./schemaFlip";

// Every list of ticked needs: flips, plus check-ins whose needs weren't saved with a flip.
export function allNeedLists(sessions, flips) {
  const withFlip = new Set(flips.map((f) => f.sessionId).filter(Boolean));
  return [
    ...flips.map((f) => f.needs || []),
    ...sessions.filter((s) => s.needs?.length && !withFlip.has(s.id)).map((s) => s.needs),
  ].map((l) => l.filter((n) => n.includes(":")));
}

export function needStats(lists) {
  const all = lists.flat();
  const counts = {};
  all.forEach((n) => (counts[n] = (counts[n] || 0) + 1));
  const items = Object.entries(counts).sort((a, b) => b[1] - a[1]).map(([k, v]) => [needLabel(k), v, k]);
  const groups = CORE_NEEDS.map((g) => [g.label, all.filter((n) => n.startsWith(`${g.key}:`)).length]).filter((x) => x[1]).sort((a, b) => b[1] - a[1]);
  return { total: all.length, items, groups };
}

export function latestIdeas(sessions, flips, limit = 6) {
  const seen = new Set();
  return [...flips, ...sessions]
    .filter((e) => e.needIdeas?.length)
    .sort((a, b) => b.timestamp.localeCompare(a.timestamp))
    .flatMap((e) => e.needIdeas.map((n) => ({ ...n, timestamp: e.timestamp })))
    .filter((n) => !seen.has(n.need) && seen.add(n.need))
    .slice(0, limit);
}
